/**
 * A list of brand codes that are internal brands and have their own theme
 */
export const INTERNAL_BRANDS_WITH_THEME = ['vio', 'goseek', 'dealbase'] as const

/**
 * A list of brand codes that are internal brands but don't have their own theme
 */
export const INTERNAL_BRANDS_WITHOUT_THEME = ['etrip', 'findhotel'] as const

/**
 * A list of brand codes that are affiliate brands and have their own theme
 */
export const EXTERNAL_BRANDS_WITH_THEME = [
  'holidaypiratesde',
  'kayak',
  'kiwi',
  'ovago',
  'weward',
  'karmanow',
  'finn',
  'hotelix',
  'elal',
  'novaair'
] as const

/**
 * Represents all possible brand codes in the system.
 * Used to identify different brands and their configurations.
 */
export const brandCodes = [
  ...INTERNAL_BRANDS_WITH_THEME,
  ...INTERNAL_BRANDS_WITHOUT_THEME,
  ...EXTERNAL_BRANDS_WITH_THEME
] as const

/**
 * Tier labels shown in the SRP sort menu. Vio surfaces its premium inventory
 * as "Gems"; every other brand labels it "Exclusive". Brand top-level variant
 * (see `Brand.tierLabel`) — it carries no boolean gate.
 */
export const TIER_LABELS = {
  Gems: 'Gems',
  PrivateDeal: 'Exclusive'
} as const
